import { atom } from 'jotai';
import { IUserDetail, IUserUnavailableDetail } from '../../models';
import { PromiseOrValue } from 'shared/utils/promise-or-value';
import { pendingQueue } from 'shared/utils/pending-queue';
import { safeAtomFamily } from 'shared/utils/safe-atom-family';

type TUserDetailStore = { [key: string]: PromiseOrValue<IUserDetail | IUserUnavailableDetail> | undefined };

export const $UserDetailV2Store = atom<TUserDetailStore>({});

/**
 * get user detail data
 *
 * use user-unique-name as key
 */
export const $UserDetailV2 = safeAtomFamily((userUniqueName: string) => {
  const a = atom<
    PromiseOrValue<IUserDetail | IUserUnavailableDetail>,
    [PromiseOrValue<IUserDetail | IUserUnavailableDetail>],
    void
  >(
    (get) => {
      const data = get($UserDetailV2Store)[userUniqueName];
      if (!data) {
        // eslint-disable-next-line @typescript-eslint/no-throw-literal
        throw new Promise((resolve) => pendingQueue.push(resolve));
      }
      return data;
    },
    (get, set, userDetail) => {
      const old = get($UserDetailV2Store);
      set($UserDetailV2Store, { ...old, [userUniqueName]: userDetail });
    },
  );

  a.debugLabel = `$UserDetailV2+${encodeURIComponent(userUniqueName)}`;

  return a;
});
